import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Shield, Lock, Database, Phone } from "lucide-react";

export default function PrivacyPolicyPage() {
  return (
    <div className="space-y-6 animate-fade-in-up" dir="rtl">
      <div className="flex items-center gap-3">
        <Shield className="w-8 h-8 text-emerald-500" />
        <h1 className="text-2xl font-bold text-white">سياسة الخصوصية</h1>
      </div>

      <div className="grid gap-6">
        {/* نبذة */}
        <Card className="bg-slate-800/50 border-slate-700">
          <CardHeader>
            <CardTitle className="text-white text-lg">نبذة عن التطبيق</CardTitle>
          </CardHeader>
          <CardContent className="text-slate-300 space-y-3">
            <p>هذا التطبيق مصمم لمساعدتك في إدارة محلك التجاري بسهولة وفعالية.</p>
            <p>نحرص على حماية بياناتك والحفاظ على خصوصيتك.</p>
          </CardContent>
        </Card>

        {/* البيانات المحفوظة */}
        <Card className="bg-slate-800/50 border-slate-700">
          <CardHeader>
            <CardTitle className="text-white text-lg flex items-center gap-2">
              <Database className="w-5 h-5 text-blue-500" />
              البيانات المحفوظة
            </CardTitle>
          </CardHeader>
          <CardContent className="text-slate-300">
            <ul className="space-y-2">
              <li>• معلومات حسابك (الاسم، البريد، رقم الهاتف)</li>
              <li>• بيانات المنتجات والمخزون</li>
              <li>• سجلات المبيعات والمشتريات</li>
              <li>• بيانات العملاء والموردين</li>
            </ul>
          </CardContent>
        </Card>

        {/* حماية البيانات */}
        <Card className="bg-slate-800/50 border-slate-700">
          <CardHeader>
            <CardTitle className="text-white text-lg flex items-center gap-2">
              <Lock className="w-5 h-5 text-emerald-500" />
              حماية البيانات
            </CardTitle>
          </CardHeader>
          <CardContent className="text-slate-300">
            <ul className="space-y-2">
              <li>• بياناتك محفوظة بشكل آمن على السيرفرات</li>
              <li>• لا نشارك بياناتك مع أي طرف ثالث</li>
              <li>• يمكنك طلب حذف بياناتك في أي وقت</li>
            </ul>
          </CardContent>
        </Card>

        {/* التواصل */}
        <Card className="bg-slate-800/50 border-slate-700">
          <CardHeader>
            <CardTitle className="text-white text-lg flex items-center gap-2">
              <Phone className="w-5 h-5 text-amber-500" />
              التواصل
            </CardTitle>
          </CardHeader>
          <CardContent className="text-slate-300">
            <p>للاستفسارات أو طلب حذف البيانات، تواصل مع مزود الخدمة.</p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
